import sha256 from 'sha256';

export async function calculateFileHash(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    // 当文件读取完成时，计算哈希值
    reader.onload = async (event) => {
      try {
        const arrayBuffer = event.target.result;
        
        // 将 ArrayBuffer 转换为字符串
        const uint8Array = new Uint8Array(arrayBuffer);
        const binaryString = Array.from(uint8Array, byte => String.fromCharCode(byte)).join('');
        
        // 使用 sha256 计算哈希值
        const hashHex = sha256(binaryString);
        console.log('hashHex正确', hashHex);
        
        resolve(hashHex);
      } catch (error) {
        console.log('reader.error错误', error);
        reject(error);
      }
    };

    // 如果文件读取失败，捕获错误
    reader.onerror = () => {
      debugger
      console.log('reader.error', reader.error);
      
      reject(reader.error);
    };

    // 读取文件为 ArrayBuffer
    reader.readAsArrayBuffer(file);
  });
}

/**
 * 从临时存储中获取token并去掉Bearer前缀
 * @param {string} storageKey - 存储token的key，默认为'access_token'
 * @returns {string|null} - 返回去掉Bearer前缀的token，如果没有找到则返回null
 */
export function getTokenFromStorage(storageKey = 'token') {
  try {
   
    let token = sessionStorage.getItem(storageKey);
  


    
    if (!token) {
      console.warn('Token not found in storage');
      return null;
    }
    
    // 如果token以'Bearer '开头，则去掉这个前缀
    if (token.startsWith('Bearer ')) {
      return token.substring(7); // 去掉'Bearer '前缀(7个字符)
    }
    
    // 如果没有Bearer前缀，直接返回token
    return token;
  } catch (error) {
    console.error('Error getting token from storage:', error);
    return null;
  }
}